(function () {

  function formatHuf(cents) {
    const amount = Math.round(Number(cents || 0) / 100);

    return new Intl.NumberFormat('hu-HU').format(amount) + ' Ft';
  }


  function getBasePrice(root) {
    const section = root.closest('.shopify-section');

    if (!section) {
      return Number(root.dataset.basePrice || 0);
    }

    const productId = root.dataset.productId;

    const priceElement =
      section.querySelector(
        `product-price[data-product-id="${productId}"] .price`
      ) ||
      section.querySelector('product-price .price');

    if (!priceElement) {
      return Number(root.dataset.basePrice || 0);
    }

    const text = priceElement.textContent || '';

    const number = Number(
      text.replace(/[^\d]/g, '')
    );

    if (!number) {
      return Number(root.dataset.basePrice || 0);
    }

    // A Shopify Liquid árai cent-alapúak.
    return number * 100;
  }


  function updateTotal(root) {
    if (!root) return;

    const totalElement =
      root.querySelector('[data-tb-extra-total]');

    if (!totalElement) return;

    const basePrice = getBasePrice(root);

    let extrasTotal = 0;

    root
      .querySelectorAll('.tb-extra-checkbox:checked')
      .forEach((checkbox) => {
        extrasTotal += Number(
          checkbox.dataset.extraPrice || 0
        );
      });

    totalElement.textContent =
      formatHuf(basePrice + extrasTotal);
  }


  function updateAllTotals() {
    document
      .querySelectorAll('[data-tb-extras]')
      .forEach(updateTotal);
  }


  /*
   * Checkbox változás
   */
  document.addEventListener('change', function (event) {

    if (
      event.target.matches('.tb-extra-checkbox')
    ) {
      const root =
        event.target.closest('[data-tb-extras]');

      updateTotal(root);

      return;
    }


    /*
     * Ha a normál termék variánsa változik
     * (méret, hab stb.), várunk arra,
     * hogy a Horizon frissítse a fő árat.
     */
    setTimeout(updateAllTotals, 250);
    setTimeout(updateAllTotals, 800);

  });


  /*
   * Első megjelenítés
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateAllTotals
    );
  } else {
    updateAllTotals();
  }


  /*
   * Témaszerkesztő / dinamikus szekció
   */
  document.addEventListener(
    'shopify:section:load',
    updateAllTotals
  );


  /*
   * KOSÁRBA HELYEZÉS
   *
   * Capture módban kapjuk el,
   * ezért a Horizon normál küldése előtt
   * tudjuk átvenni az irányítást.
   */
  document.addEventListener(
    'submit',

    async function (event) {

      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const section =
        form.closest('.shopify-section');

      if (!section) return;


      const root =
        section.querySelector('[data-tb-extras]');

      if (!root) return;


      const selectedExtras = [
        ...root.querySelectorAll(
          '.tb-extra-checkbox:checked'
        )
      ];


      /*
       * Ha nincs extra kiválasztva,
       * minden marad a Horizon
       * eredeti működése szerint.
       */
      if (selectedExtras.length === 0) {
        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();


      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }


      const formData =
        new FormData(form);


      const parentId =
        Number(formData.get('id'));


      if (!parentId) {
        alert(
          'Nem található a kiválasztott termékváltozat.'
        );
        return;
      }


      const productForm =
        form.closest('product-form-component');


      const quantityInput =
        productForm?.querySelector(
          'input[name="quantity"]'
        );


      const quantity =
        Number(
          quantityInput?.value ||
          formData.get('quantity') ||
          1
        );


      /*
       * Megtartjuk a bútor minden
       * jelenlegi egyedi adatát.
       */
      const properties = {};


      for (
        const [key, value]
        of formData.entries()
      ) {

        const match =
          key.match(
            /^properties\[(.+)\]$/
          );


        if (
          match &&
          String(value).trim() !== ''
        ) {

          properties[match[1]] =
            String(value);

        }

      }


      properties['Kiválasztott extrák'] =
        selectedExtras
          .map(
            checkbox =>
              checkbox.dataset.extraName
          )
          .join(', ');


      /*
       * Fő bútor
       */
      const mainItem = {
        id: parentId,
        quantity: quantity,
        properties: properties
      };


      const sellingPlan =
        formData.get('selling_plan');


      if (sellingPlan) {
        mainItem.selling_plan =
          sellingPlan;
      }


      const items = [
        mainItem
      ];


      /*
       * Feláras termékek
       */
      selectedExtras.forEach(
        function (checkbox) {

          items.push({

            id: Number(
              checkbox.dataset.extraVariantId
            ),

            quantity: quantity,

            /*
             * Ez kapcsolja hozzá
             * a fő bútorhoz.
             */
            parent_id: parentId,

            properties: {
              '_Kapcsolódó termék':
                root.dataset.productTitle
            }

          });

        }
      );


      const button =
        form.querySelector(
          'button[type="submit"]'
        );


      if (button) {
        button.disabled = true;
      }


      try {

        const response =
          await fetch(
            window.Shopify.routes.root +
              'cart/add.js',

            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',
                'Accept':
                  'application/json'
              },

              body: JSON.stringify({
                items: items
              })
            }
          );


        const result =
          await response.json();


        if (!response.ok || result.status) {

          throw new Error(
            result.description ||
            result.message ||
            'Nem sikerült a kosárba helyezés.'
          );

        }


        /*
         * Első körben direkt a kosárra
         * visszük a vásárlót.
         * Így biztosan látjuk, hogy
         * ténylegesen bekerült-e minden.
         */
        window.location.href =
          window.Shopify.routes.root +
          'cart';


      } catch (error) {

        console.error(
          'Topbútor extra hiba:',
          error
        );

        alert(
          error.message ||
          'Hiba történt a kosárba helyezéskor.'
        );

        if (button) {
          button.disabled = false;
        }

      }

    },

    true
  );

})();